import { ZxcvbnFactory, type ZxcvbnResult } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MIN_ZXCVBN_SCORE,
  type PasswordValidationReason,
  type ZxcvbnScore,
} from '@nest-react/domain';

let zxcvbn: ZxcvbnFactory | null = null;

const ensureZxcvbn = (): ZxcvbnFactory => {
  if (!zxcvbn) {
    zxcvbn = new ZxcvbnFactory({
      translations: zxcvbnEnPackage.translations,
      graphs: zxcvbnCommonPackage.adjacencyGraphs,
      dictionary: {
        ...zxcvbnCommonPackage.dictionary,
        ...zxcvbnEnPackage.dictionary,
      },
    });
  }
  return zxcvbn;
};

export type PasswordValidationResult = {
  valid: boolean;
  score: ZxcvbnScore;
  reason?: PasswordValidationReason;
};

export const assessPassword = (
  password: string,
  userInputs: string[] = []
): ZxcvbnResult => {
  const sanitizedInputs = userInputs
    .map(value => value.trim())
    .filter(value => value.length > 0);
  return ensureZxcvbn().check(password, sanitizedInputs);
};

export const validatePasswordForRegistration = (
  password: string,
  userInputs: string[] = []
): PasswordValidationResult => {
  const result = assessPassword(password, userInputs);
  const score = result.score as ZxcvbnScore;

  if (password.length < PASSWORD_MIN_LENGTH) {
    return { valid: false, score, reason: 'too_short' };
  }
  if (score < PASSWORD_MIN_ZXCVBN_SCORE) {
    return { valid: false, score, reason: 'too_weak' };
  }
  return { valid: true, score };
};
